import { AxiosError } from 'axios'
import * as Sentry from '@sentry/react'
import { toast } from '@/hooks/use-toast'

export function handleServerError(error: unknown) {
  const environment = import.meta.env.VITE_ENVIRONMENT || 'PRODUCTION'
  if (environment !== 'LOCAL') {
    Sentry.captureException(error)
  }

  let errMsg = 'Something went wrong!'

  if (
    error &&
    typeof error === 'object' &&
    'status' in error &&
    Number(error.status) === 204
  ) {
    errMsg = 'Content not found.'
  }

  if (error instanceof AxiosError) {
    errMsg = error.response?.data.title
  }

  toast({ variant: 'destructive', title: errMsg })
}
